// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__iURrT","large":"styles_large__G1niF"};